import { useState } from 'react';
import {
  loginRequest,
  verifyLoginCodeRequest,
} from '@services/auth/authApi';

// Encapsulates login API call and local submit/error state.
function useLogin() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [challenge, setChallenge] = useState(null);

  async function executeLogin(payload) {
    // Keep API errors available to the form and rethrow for caller-specific handling.
    setError('');
    setIsSubmitting(true);
    try {
      const response = await loginRequest(payload);
      setChallenge(response?.body || null);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  }

  async function executeVerifyLoginCode(payload) {
    setError('');
    setIsSubmitting(true);
    try {
      const response = await verifyLoginCodeRequest(payload);
      setChallenge(null);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  }

  function resetChallenge() {
    setChallenge(null);
  }

  return {
    executeLogin,
    executeVerifyLoginCode,
    isSubmitting,
    error,
    setError,
    challenge,
    resetChallenge,
  };
}

export default useLogin;
